export const ACTIVATION_REQUEST_STATUSES = {
  ACCEPT: "ACCEPT",
  REJECT: "REJECT",
  PENDING: "pending",
  INCOMPLETE: "INCOMPLETE",
  PENDINGANDCOMPLETE: "pending and INCOMPLETE",
};
